export default function PageNotFound() {
    return (
        <code>404 Not Found</code>
    );
}
